// extracted by mini-css-extract-plugin
export var danger = "_3i-6";
export var lightPink = "_3i-a";
export var medium = "_3i-j";
export var nearSquare = "_3i-m";
export var neutralBlue = "_3i-8";
export var neutralYellow = "_3i-7";
export var noCapitalize = "_3i-1";
export var normal = "_3i-2";
export var pill = "_3i-0";
export var primary = "_3i-3";
export var primaryLight = "_3i-4";
export var shadow = "_3i-n";
export var small = "_3i-k";
export var solidBlack = "_3i-i";
export var solidGreen = "_3i-d";
export var solidLightBlue = "_3i-f";
export var solidNavy = "_3i-e";
export var solidOrange = "_3i-h";
export var solidPink = "_3i-g";
export var solidRed = "_3i-b";
export var solidWhite = "_3i-9";
export var solidYellow = "_3i-c";
export var success = "_3i-5";
export var xsmall = "_3i-l";